const closeButtonSelector = "#right-sidebar-close";
const sidebarSelector = "#right-sidebar";
const sidebarContentSelector = "#right-sidebar-content";
const sidebarTitleSelector = "#right-sidebar-title";

const animationDelay = 300;

let sidebarShown = false;

$(window).resize(function(){
    $(sidebarSelector).css({"right" : 0});
});

$(document).ready(function(){
    $(closeButtonSelector).click(function (){
        hideRightSidebar();
        setTimeout(function(){
            clearRightSidebar();
        }, animationDelay)
    })

    $(sidebarSelector).resizable({
        minWidth: 500,
        handles: "w"
    });

})

function clearRightSidebar(){
    $(sidebarTitleSelector).text('');
    $(sidebarContentSelector).html('');
}

function clearRightSidebarContent(){
    $(sidebarContentSelector).html('');
}

function setRightSidebarContent(html){
    $(sidebarContentSelector).html(html);
}

function setRightSidebarTitle(title){
    $(sidebarTitleSelector).text(title);
}

function showRightSidebar(){
    $(sidebarSelector).show("slide", {direction: "right"}, animationDelay);
    sidebarShown = true;
}

function hideRightSidebar(){
    $(sidebarSelector).hide("slide", {direction: "right"}, animationDelay);
    $("div.datagrid").find("tr.grid-row-selected").removeClass("grid-row-selected");
    sidebarShown = false;
}

function setGridRowAsSelected(id, gridName){
    const selector = `div.datagrid-${gridName}`;
    $(selector).find("tr.grid-row-selected").removeClass("grid-row-selected");
    $(selector).find(`tr[data-id=${id}]`).addClass("grid-row-selected");
}

// event handlers

// SOAP SIDEBAR
$(document).ready(function() {
    $(document).on('click', '.soap-toggle-sidebar-detail', function () {

        if(sidebarShown){
            clearRightSidebarContent();
        }

        const id = $(this).data('id');
        const redisKey = $(this).data('redis-key');
        const sid = $(this).data('sid');

        let url = BASE_URL + `admin/protokol/soap-sidebar-detail/${id}`;
        const query = {};

        if(redisKey){
            query.redisKey = redisKey;
        }

        if(sid){
            query.sid = sid;
        }

        if(Object.keys(query).length > 0){
            url += `?${$.param(query)}`;
        }

        setGridRowAsSelected(id, 'soapGrid');

        $.get(url, function (data) {
            setRightSidebarContent(data);

            if(!sidebarShown){
                setRightSidebarTitle('Detail SOAP komunikace')
                showRightSidebar();
            }

            onSoapSidebarLoaded();
        });
    });

    $(document).on('click', '#soapSidebarDetailTab button', function () {
        $(sidebarSelector).attr('data-soap-detail-tab-selected', $(this).attr('id'));
    });

    function onSoapSidebarLoaded(){
        const tabId = $(sidebarSelector).attr("data-soap-detail-tab-selected");
        if(tabId !== undefined){
            $("#soapSidebarDetailTab button").attr('aria-selected', 'false').removeClass('active');
            $("#" + tabId).attr('aria-selected', 'true').addClass('active');
            $("div.tab-pane").removeClass('active').removeClass('show');
            $("div[aria-labelledby=\""+tabId+"\"]").addClass('active').addClass('show');
        }
    }
});

// REST SIDEBAR
$(document).ready(function() {
    $(document).on('click', '.rest-log-toggle-sidebar-detail', function () {

        if(sidebarShown){
            clearRightSidebarContent();
        }

        const id = $(this).data('id');
        const url = BASE_URL + `admin/protokol/rest-log-sidebar-detail/${id}`;

        setGridRowAsSelected(id, 'restLogGrid');

        $.get(url, function (data) {
            setRightSidebarContent(data);

            if(!sidebarShown){
                setRightSidebarTitle('Detail Rest komunikace')
                showRightSidebar();
            }

            onRestSidebarLoaded();
        });
    });

    $(document).on('click', '#restLogSidebarDetailTab button', function () {
        $(sidebarSelector).attr('data-rest-detail-tab-selected', $(this).attr('id'));
    });

    function onRestSidebarLoaded(){
        const tabId = $(sidebarSelector).attr("data-rest-detail-tab-selected");
        if(tabId !== undefined){
            $("#restLogSidebarDetailTab button").attr('aria-selected', 'false').removeClass('active');
            $("#" + tabId).attr('aria-selected', 'true').addClass('active');
            $("div.tab-pane").removeClass('active').removeClass('show');
            $("div[aria-labelledby=\""+tabId+"\"]").addClass('active').addClass('show');
        }
    }
});

let previousId = null;
// FILE SIDEBAR
$(document).ready(function() {
    $(document).on('click', '.component-toggle-sidebar-detail', function () {
        const id = $(this).data('id');
        const url = BASE_URL + `dokumenty/dokument-to-file-detail?dtfId=${id}`;
        let continueScript = true;

        if(sidebarShown){
            clearRightSidebarContent();
            if (previousId === id) {
                hideRightSidebar();
                continueScript = false
            }
        }

        previousId = id;

        if (continueScript) {
            setGridRowAsSelected(id, 'dokumentPrilohyUzivatelskeGrid');

            $.get(url, function (data) {
                setRightSidebarContent(data);

                if(!sidebarShown){
                    setRightSidebarTitle('Detail komponenty')
                    showRightSidebar();
                }
            });
        }
    });

    $(document).on('click', '#componentSidebarDetailTab button', function () {
        $(sidebarSelector).attr('data-component-detail-tab-selected', $(this).attr('id'));
    });
});


/**
 * Načte a zobrazí detail součásti typového spisu v postranním panelu. Pokud je panel již zobrazen
 * a uživatel klikne na stejnou součást, panel se skryje.
 *
 * @param {number|string} id Identifikátor součásti typového spisu, jehož detail má být načten a zobrazen.
 * @return {void} Nevrací žádnou hodnotu.
 */
function loadTypovySpisSoucastToggleSidebarDetail(id){
	const url = BASE_URL + `typove-spisy/soucast-detail?dtfId=${id}`;
	let continueScript = true;

	if(sidebarShown){
		clearRightSidebarContent();
		if (previousId === id) {
			hideRightSidebar();
			continueScript = false
		}
	}

	previousId = id;

	if (continueScript) {
		$.get(url, function (data) {
			setRightSidebarContent(data);
			setRightSidebarTitle('Detail součásti');

			if(!sidebarShown){
				showRightSidebar();
			}
		});
	}
}


// Typovy spis soucast side bar
$(document).ready(function() {
	$(document).on('click', '.typovy-spis-soucast-toggle-sidebar-detail', function () {
		const id = $(this).data('id');
		loadTypovySpisSoucastToggleSidebarDetail(id);
	});

	$(document).on('click', '#typovySpisSoucastDetailTab button', function () {
		$(sidebarSelector).attr('data-typovy-spis-soucast-detail-tab-selected', $(this).attr('id'));
	});
});

// Typovy spis dil side bar
$(document).ready(function() {
	$(document).on('click', '.typovy-spis-dil-toggle-sidebar-detail', function () {
		const id = $(this).data('id');
		const url = BASE_URL + `typove-spisy/dil-detail?dtfId=${id}`;
		let continueScript = true;

		if(sidebarShown){
			clearRightSidebarContent();
			if (previousId === id) {
				hideRightSidebar();
				continueScript = false
			}
		}

		previousId = id;

		if (continueScript) {
			$.get(url, function (data) {
				setRightSidebarContent(data);
				setRightSidebarTitle('Detail dílu');

				if(!sidebarShown){
					showRightSidebar();
				}
			});
		}
	});

	$(document).on('click', '#typovySpisDilDetailTab button', function () {
		$(sidebarSelector).attr('data-typovy-spis-dil-detail-tab-selected', $(this).attr('id'));
	});
});
